var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{class:{
        'col-left': true,
        'my-auto': true,
      },attrs:{"cols":"auto"}},[_vm._v("\n      "+_vm._s(_vm.testSelected ? _vm.testSelected.name: null)+"\n    ")]),_c('b-col',{class:{
        'col-left': true,
        'my-auto': true,
      },attrs:{"cols":"auto"}},[_c('b-button',{class:{
          'tab-button': true,
        },attrs:{"size":"sm"},on:{"click":function($event){return _vm.$emit('back', 'subTest')}}},[_vm._v("\n        ย้อนกลับ\n      ")])],1),_c('b-col',{class:{
        'col-left': true,
        'my-auto': true,
      },attrs:{"cols":"auto"}},[_c('b-button',{class:{
          'tab-button': true,
          'active': _vm.tabSelectedComputed === 'editSubSubTest'
        },attrs:{"size":"sm"},on:{"click":function($event){return _vm.$emit('input', 'editSubSubTest')}}},[_vm._v("\n        ข้อมูลทั่วไป\n      ")])],1),_c('b-col',{class:{
        'col-left': true,
        'my-auto': true,
      },attrs:{"cols":"auto"}},[_c('b-button',{class:{
          'tab-button': true,
          'active': _vm.tabSelectedComputed === 'subSubTestRefRange'
        },attrs:{"size":"sm"},on:{"click":function($event){return _vm.$emit('input', 'subSubTestRefRange')}}},[_vm._v("\n        Ref Range\n      ")])],1)],1),(_vm.tabSelectedComputed === 'subSubTestRefRange' || _vm.tabSelectedComputed === 'refRangeMultiCreate')?[_c('b-row',{staticClass:"pt-3 mt-3 sub-panel"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"success","size":"sm"},on:{"click":_vm.updateRefRangeHandler}},[_vm._v("\n          บันทึก\n        ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{class:{
            'tab-button': true,
            'active': _vm.tabSelectedComputed === 'refRangeMultiCreate'
          },attrs:{"size":"sm"},on:{"click":function($event){return _vm.$emit('input', 'refRangeMultiCreate')}}},[_vm._v("\n          เพิ่มค่า Ref Range\n        ")])],1)],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }